import { ThemeModule } from '../../front/lib/ThemeModule';
import { createApp } from 'vue';
import PrimaryListSearchApp from './PrimaryListSearchApp.vue';
export class ArticlesGrid extends ThemeModule {
    init() {
        if (this.json.primarySearch.enabled) {
            const rootEl = this.getElementById('primarySearch');
            if (rootEl) {
                this.initSearch(rootEl);
            }
        }
    }
    initSearch(rootEl) {
        const app = createApp(PrimaryListSearchApp, { mod: this });
        app.mount(rootEl);
    }
    setBusyStatus(busy) {
        if (busy) {
            this.root.classList.add('is--busy');
        }
        else {
            this.root.classList.remove('is--busy');
        }
    }
    replaceSearchResults(rawHtml) {
        // Parse the raw HTML string into a document fragment
        // then extract and replace the featured and list sections
        // let browser handle all GC
        const tpl = document.createElement('template');
        tpl.innerHTML = rawHtml;
        const fragments = [].slice.apply(tpl.content.children).filter((el) => el instanceof HTMLElement);
        for (const fragment of fragments) {
            if (['featured', 'list'].includes(fragment.dataset.section || '')) {
                const replacementTarget = this.querySelector(`[data-section="${fragment.dataset.section}"]`);
                if (replacementTarget) {
                    replacementTarget.replaceWith(fragment);
                }
            }
        }
    }
}
